import { render, staticRenderFns } from "./PdfItem.vue?vue&type=template&id=1e0dd7b7&"
import script from "./PdfItem.vue?vue&type=script&lang=ts&"
export * from "./PdfItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports